import React from 'react';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';

// styles
import './ycTeam.scss';

import imgAK from '../../assets/images/c-team/anthony.png';
import imgJC from '../../assets/images/c-team/jeanclaude.png';
import imgJW from '../../assets/images/c-team/julien.png';
import imgLM from '../../assets/images/c-team/louis.png';
import imgLY from '../../assets/images/c-team/lucas.png';
// import imgMA from '../../assets/images/c-team/masculin.png';
import imgMT from '../../assets/images/c-team/matthias.png';
import imgRM from '../../assets/images/c-team/robin.png';
import imgRF from '../../assets/images/c-team/romain.png';
import imgTY from '../../assets/images/c-team/thomas.png';
import imgNG from '../../assets/images/c-team/nicolasg.png';

export const YcTeam = withTranslation(['about-us'])(
  class YcTeamClassClass extends React.PureComponent {
    teams = [
      [
        { img: imgLY, name: 'Lucas Yalap', job: 'CEO & CTO', desc: 'about-us.founder.lucas' },
        {
          img: imgJC,
          name: 'Jean-Claude Yalap',
          job: 'Founder & Lead Developer',
          desc: 'about-us.founder.jc',
        },
      ],
      [
        { img: imgJW, name: 'Julien' },
        { img: imgTY, name: 'Thomas' },
        { img: imgMT, name: 'Matthias' },
      ],
      [
        { img: imgRF, name: 'Romain' },
        { img: imgLM, name: 'Louis' },
      ],
      [
        { img: imgRM, name: 'Robin' },
        { img: imgAK, name: 'Anthony' },
        { img: imgNG, name: 'Nicolas' },
      ],
    ];

    componentDidMount() {
      $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidUpdate() {
      $('[data-toggle="tooltip"]').tooltip();
    }

    renderLine() {
      return this.teams.map((p, index) => <div className="content row justify-content-center">{this.renderTeam(p)}</div>);
    }

    renderTeam(line) {
      return line.map((p, index) => (
        <div className="avatar" key={index}>
          {!p.name ? (
            <img className="avatar-img" src={p.img} alt="back ground avatar" id="avatar" />
          ) : (
              <img
                className="avatar-img"
                src={p.img}
                alt="back ground avatar"
                data-toggle="tooltip"
                data-html="true"
                data-placement="right"
                title={`<div class="avatar-desc"><b>${p.name}</b><br/>${p.job || ''}</div>`}
                id="avatar"
              />
            )}
        </div>
      ));
    }
    renderTeamMobile(line) {
      return line.map((p, index) => (
        <div className="col-md-3 col-6" key={index}>
          {!p.name ? (
            <div></div>
          ) : (
              <img
                className="avatar-img"
                src={p.img}
                alt="back ground avatar"
                data-toggle="tooltip"
                data-html="true"
                data-placement="right"
                title={`<b>${p.name}</b>${p.job ? `${p.job}<br/>` : ''}`}
                id="avatar"
              />
            )}
        </div>
      ));
    }

    render() {
      const { t } = this.props;

      return (
        <div className="c-team">
          <h2 dangerouslySetInnerHTML={{ __html: t('about-us.team.title') }} />
          <p className="desc" dangerouslySetInnerHTML={{ __html: t('about-us.team.desc') }} />
          <div className="desktop">{this.renderLine()}</div>
          <div className="mobile">
            <div className="row justify-content-center">{this.renderTeamMobile(this.teams[0])}</div>
            <div className="row justify-content-center">
              {this.renderTeamMobile(this.teams[1])}
              {this.renderTeamMobile(this.teams[2])}
              {this.renderTeamMobile(this.teams[3])}
            </div>
          </div>
        </div>
      );
    }
  },
);
